import React, { useState } from 'react'
import { Menu, MenuItem } from '@mui/material'
import Spacer from '../Spacer'
import CustomCheckbox from '../CustomCheckbox'
import { truncateText } from 'src/heplers'

const RadioSelectObjMulti = ({ options, onSelectOption, style, placeholder, value, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    if (!disabled) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleSelect = s => {
    onSelectOption(s.id)
  }
  const stringValue =
    options.length && Array.isArray(value)
      ? options
          .filter(opt => value?.includes(opt.id))
          .map(el => el.name)
          .join(', ')
      : placeholder
  return (
    <>
      <div
        onClick={handleClick}
        style={{ ...style, opacity: disabled ? 0.7 : 1 }}
        className='row row-center select-type'
      >
        <p
          style={{
            marginRight: '10px',
            fontSize: '13px',
            fontWeight: '600',
            textTransform: 'capitalize'
          }}
        >
          {truncateText(stringValue || '', 30)}
        </p>
        <Spacer />
        <svg
          style={{
            transition: '0.4s',
            transform: open && 'rotate(180deg)'
          }}
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3 5.33337L8 10.3334L13 5.33337' stroke='#1B1B26' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>
      <Menu
        sx={{
          '& .MuiPaper-root': {
            // width: style?.width,
            color: '#1B1B26',
            borderRadius: '12px',
            maxHeight: '400px'
          },
          '& li': {
            fontFamily: 'Plus Jakarta Sans'
          },
          '& li:hover': {}
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {options.map(el => (
          <MenuItem sx={{ textTransform: 'capitalize', maxWidth: 500, padding: '2px 6px' }} key={el}>
            <div style={{ marginRight: '8px' }}>
              <CustomCheckbox onClick={() => handleSelect(el)} checked={value?.includes(el.id)} />
            </div>
            <div style={{ width: '100%', position: 'relative' }}>
              <p style={{ maxWidth: 300 }} className='text-shrink-1'>
                {el.name}
              </p>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default RadioSelectObjMulti
